import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolsBox1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tools-box-1" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 6.75,
			width: 22.5,
			height: 15,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25,6.75v-3a1.5,1.5,0,0,0-1.5-1.5H8.25a1.5,1.5,0,0,0-1.5,1.5v3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25,11.25a2.987,2.987,0,0,0-2.584,1.5H9.334a3,3,0,1,0,0,3h5.332a2.995,2.995,0,1,0,2.584-4.5Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 14.25,
			x2: 6.75,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 14.25,
			x2: 20.25,
			y2: 14.25
		})
	]
});
export default SvgToolsBox1;
